import React, { Fragment } from 'react'
import { Toast } from 'react-bootstrap'
import 'recupero-comunes/dist/index.css'

const Mensajes = ({ showToast, handleCloseToast, delay, responseData}) => {

    return (
        <Fragment>
            <style type='text/css'>
                {`
                    .toast {
                        --bs-toast-max-width: 600px;
                        width: 600px;
                    }
                `}
            </style>
            <Toast onClose={handleCloseToast} show={showToast} delay={delay} autohide >
                <Toast.Header style={{ backgroundColor: responseData?.code === 1 ? '#4CAF50' : responseData?.code === 11 ? '#fc9d03' : 'red', color: 'white' }}>
                    <strong className="me-auto">{responseData?.code === 1 ? 'Respuesta Satisfactoria' : responseData?.code === 11 ? 'Atención!' : 'Error'}</strong>
                </Toast.Header>
                <Toast.Body>
                    {responseData ? responseData?.message : "Enviando ..."}
                </Toast.Body>
            </Toast>

        </Fragment>
    )
}
export default Mensajes;